var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-logo logo",attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.redirectToHome}},[_c('svg-icon',{staticClass:"logo__icon",attrs:{"original":"","name":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }